import { IconMenu } from "../shared";

interface MobileHeaderProps {
  title: string;
  onMenuClick: () => void;
  alertCount?: number;
}

export function MobileHeader({ title, onMenuClick, alertCount = 0 }: MobileHeaderProps) {
  return (
    <div className="bg-white border-b border-slate-200 px-4 py-3 flex items-center justify-between">
      <button
        onClick={onMenuClick}
        className="bg-transparent border-none cursor-pointer p-1 min-w-[44px] min-h-[44px] flex items-center justify-center hover:bg-slate-100 rounded-lg transition-colors text-slate-700"
        aria-label="Open menu"
      >
        <IconMenu size={24} />
      </button>
      <span className="font-bold text-base text-slate-800">{title}</span>
      {alertCount > 0 ? (
        <span className="bg-red-500 text-white px-2 py-0.5 rounded-full text-xs font-semibold min-w-[44px] text-center">
          {alertCount}
        </span>
      ) : (
        <div className="w-11" />
      )}
    </div>
  );
}
